import { __decorate } from "tslib";
import { OtherName } from "@peculiar/asn1-x509";
import { AsnType, AsnTypeTypes } from "@peculiar/asn1-schema";
export const id_ntPrincipalName = "1.3.6.1.4.1.311.20.2.3";
let NTPrincipalName = class NTPrincipalName extends OtherName {
};
NTPrincipalName = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence })
], NTPrincipalName);
export { NTPrincipalName };
